import FeaturedGuides from './featured_guides';
import initializeComponent from '../../Shared/react-initialize';

initializeComponent('FeaturedGuides', FeaturedGuides);
